import { render, staticRenderFns } from "./tradeRecord.vue?vue&type=template&id=11232b3d"
import script from "./tradeRecord.vue?vue&type=script&lang=js"
export * from "./tradeRecord.vue?vue&type=script&lang=js"
import style0 from "./tradeRecord.vue?vue&type=style&index=0&id=11232b3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports